import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';

import AppRoutes from './components/Routes/AppRoutes';
import CookieConsent from './components/CookieConsent/CookieConsent';
import LogIn from './pages/Auth/login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Invitation from './pages/Invitation/Invitation';
import { isAuthenticated } from './utilities/authentication';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loadLanguage } from './store/Language/LanguageSlice';
import { getThemeMode } from './store/Theme/ThemeSlice';


function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadLanguage());
    dispatch(getThemeMode());
  }, [dispatch]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public invitation route (accessible without auth) */}
          <Route path='/invite/:token' element={<Invitation />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/reset-password' element={<ResetPassword />} />
          
          {isAuthenticated() ? (
            <>
              {/* Demo / login links from the marketing site land here when already signed in */}
              <Route path='/login' element={<Navigate to="/dashboard" replace />} />
              <Route path='/*' element={<AppRoutes />} />
            </>
          )
            :
            <>
              <Route path='/' element={<LogIn />} />
              <Route path='/login' element={<LogIn />} />
              <Route path='*' element={<LogIn />} />
            </>
          }
        </Routes>
      </BrowserRouter>
      <CookieConsent />
    </>
  );
}

export default App;
